import {
  ChildEntity,
} from './childEntity';
import { Birthday } from './valueObjects/birthday';
import { ChildId } from './valueObjects/childId';
import { FamilyName } from './valueObjects/familyName';
import { FamilyNameKana } from './valueObjects/familyNameKana';
import { Gender } from './valueObjects/gender';
import { Name } from './valueObjects/name';
import { NameKana } from './valueObjects/nameKana';
import { ParentId } from './valueObjects/parentId';

import type {
  ChildProps,
} from './childEntity';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';

import { Factory } from '@/domain/factory';

export class ChildFactory extends Factory<
  ChildEntity,
  ChildProps,
  ChildJson
> {
  comparePvt = (a: ChildJson, b: ChildJson) => a.childId.localeCompare(b.childId, 'en');

  createPvt(props: ChildProps): ChildEntity {
    return new ChildEntity(props, null);
  }

  createFromJsonPvt(props: ChildJson): ChildEntity {
    return this.createPvt({
      parentId: ParentId.create(props.parentId),
      childId: ChildId.create(props.childId),
      name: Name.create(props.name),
      nameKana: NameKana.create(props.nameKana),
      familyName: FamilyName.create(props.familyName),
      familyNameKana: FamilyNameKana.create(props.familyNameKana),
      gender: Gender.create(props.gender),
      birthday: Birthday.create(new Date(props.birthday)),
    });
  }
}
